import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredRedeemFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter="url(#filter0_i_15069_275044)">
      <path
        d="M8.48817 0.807004L10.5747 5.2546L15.5255 5.82932C15.981 5.8821 16.1637 6.43511 15.827 6.74124L12.1656 10.0646L13.1393 14.8676C13.2289 15.3098 12.7501 15.6511 12.3495 15.4312L8.00043 13.0373L3.65134 15.4312C3.25135 15.6517 2.77197 15.3098 2.86151 14.8676L3.83521 10.0646L0.173256 6.74124C-0.163448 6.4357 0.0192319 5.8821 0.474737 5.82932L5.4256 5.2546L7.51209 0.807004C7.70432 0.397665 8.29594 0.397665 8.48817 0.807004Z"
        fill="url(#paint0_linear_15069_275044)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_15069_275044"
        x={0}
        y={-1.5}
        width={16.0002}
        height={17}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-2} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_15069_275044"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15069_275044"
        x1={12.9447}
        y1={16.0413}
        x2={5.96827}
        y2={3.17149}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A3FF" />
        <stop offset={1} stopColor="#83EAEC" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredRedeemFilled)
const IconSvgColouredRedeemFilled = createIcon(
  ForwardRef,
  'SvgColouredRedeemFilled',
)
export default IconSvgColouredRedeemFilled
